export default "__VITE_ASSET__942a6c67__"